module.exports = __webpack_public_path__ + "img/fdc8d08.svg";